import axios from "axios";
import { API_END_POINTS } from "../../API_END_POINTS";

const KLARNA_URL = `${process.env.REACT_APP_API_URL}${API_END_POINTS.kalranaPayment}`;

const generateOrder = async (orderId) => {
  const response = await axios.get(`${KLARNA_URL}/${orderId}`, {
    headers: {
      "Content-Type": "application/json",
      authorization: `Bearer ${localStorage.getItem("authToken")}`,
    },
  });
  return response.data;
};

const klarnaService = { generateOrder };
export default klarnaService;
